import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

const SentencePayment = props => {
  const { myType } = props;
  const payment = useSelector(state =>
    state.deadlinesDetail.subjective
      ? state.deadlinesDetail.subjective.payment
      : null);
  const rejected = useSelector(state =>
    state.deadlinesDetail.subjective
      ? state.deadlinesDetail.subjective.status.rejected
      : null);
  const scope = useSelector(state =>
    state.deadlinesDetail.subjective
      ? state.deadlinesDetail.subjective.scope
      : null);

  const totalAmount = useSelector(state =>
    state.deadlinesDetail.subjective
      ? state.deadlinesDetail.subjective.totalAmount
      : null);

  let sentence;

  if (payment.status === "paid" || totalAmount > 0) return "";

  switch (payment.type) {
  case "item_pays":
    // PAGA IL CLIENTE
    if (payment.compensation) {
      // CON COMPENSAZIONE
      sentence = (
        <FormattedMessage id="deadlines.pages.detail.itemPaysSentence1" />
      );
    } else {
      // SENZA COMPENSAZIONE
      if (scope === "fiscal_social_security") {
        sentence = (
          <FormattedMessage id="deadlines.pages.detail.itemPaysSentence2" />
        );
      }
    }

    break;
  case "manager_pays":
    // PAGA IL COMMERCIALISTA
    if (!rejected) {
      if (myType === "STUDIO") {
        sentence = (
          <FormattedMessage id="deadlines.pages.detail.managerPaysSentence1" />
        );
      } else {
        sentence = (
          <FormattedMessage id="deadlines.pages.detail.managerPaysSentence2" />
        );
      }
    }
    break;
  case "manager_charge":
    // ADDEBITO AL COMMERCIALISTA
    if (!rejected) {
      let sentenceArray = [];
      if (myType === "STUDIO") {
        sentenceArray.push("deadlines.pages.detail.managerChargeSentence1");
        sentenceArray.push(payment.mode.iban ? "deadlines.pages.detail.managerChargeSentence2_1"
          :  "deadlines.pages.detail.managerChargeSentence2_2");

      } else {
        sentenceArray.push("deadlines.pages.detail.managerChargeSentence3");
        sentenceArray.push(payment.mode.iban ?
          "deadlines.pages.detail.managerChargeSentence2_1"
          :  "deadlines.pages.detail.managerChargeSentence2_2" );
      }
      sentence = <Fragment>
        <FormattedMessage id={sentenceArray[0]}/>
        <FormattedMessage id={sentenceArray[1]}/>
        {payment.mode.iban ? payment.mode.iban : ""}
      </Fragment>;
    }
    break;
  default: {
    sentence = "";
    break;
  }
  }

  return <div style={{ margin: "32px 0" }}>{sentence}</div>;
};

export default SentencePayment;
